import { AuthState } from 'old/atoms/auth';
import { useCallback } from 'react';
import { Outlet } from 'react-router';
import { AuthenticatedNotFound } from '../../../pages/authenticated-not-found';

/**
 * @deprecated This is temporal hack for upgrade React Router v5 to v6
 * Do not use this, find better solution
 */
const PermissionGuard = ({ permissions }: { permissions: Array<{ scope: string }> }) => {
  const render = useCallback((isAllowed: boolean) => {
    if (isAllowed) {
      return <Outlet />;
    }

    // TODO: Maybe forbidden page instead?
    return <AuthenticatedNotFound />;
  }, []);

  return <AuthState permissions={permissions} render={render} />;
};

export default PermissionGuard;
